export default "/event-schedule-banner.33a344c2-ce4d71.png";